import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import type { StyleProps } from './types'

export const label = ({ theme }: StyleProps): CSSObject => ({
  alignItems: 'center',
  display: 'flex',
  // The design's label style. Semibold is not a face every page loads, and
  // where it is missing a label fell back to regular weight.
  ...Typography.H50,
  color: Color[theme].Text.Default,

  '&::after': {
    content: '""',
    marginInlineStart: Spacing.XS,
    color: 'inherit',
  },

  '&[aria-disabled="true"]': {
    opacity: 0.5,
  },
  '&[data-required="true"]::after': {
    content: '"*"',
  },
  '&[data-valid="false"]::after': {
    color: Color[theme].Text.Warning,
  },
})
